// app/javascript/projects/components/ProjectsDisplay.jsx
import React from 'react';
import BillingModalMainBillingCanceled from './BillingModalMainBillingCanceled';
import BillingModalMainBillingTrialing from './BillingModalMainBillingTrialing';
import BillingModalMainBillingActive from './BillingModalMainActive';
import { useSubscription } from '../../../hooks/subscriptions/queries';


function BillingModalMainBilling() {
  // Get subscription data from hooks
  const { data: subscription } = useSubscription();
  
  // Check subscription status
  const status = subscription?.status;
  const canceled = subscription?.cancel_at_period_end;

  if ( !status ) {
    return null;
  }
  else if ( status == 'canceled' || canceled ) {
    return <BillingModalMainBillingCanceled subscription={subscription} />
  } else if ( status == 'trialing' ) {
    return <BillingModalMainBillingTrialing subscription={subscription} />
  } else {
    return <BillingModalMainBillingActive subscription={subscription} />
  }
}

export default BillingModalMainBilling;
